module.exports = __webpack_public_path__ + "img/sedan_driving.35b4fcc4.svg";